<template>
  <div class="contact-tab">
    <h3>Learn more</h3>
    <p class="my-5">
      This Virtual Deal Room is established to increase investment on both
      private and publicly originated deals, and is funded by the Gabonese
      government.
    </p>
    <p>
      It is operated by Asoko Insight Limited, a leading custom deal flow
      platform vendor. For more information, please contact
      <a href="mailto:dealroom@asokoinsight.com">dealroom@asokoinsight.com</a>.
    </p>
    <!-- <p>
      <a href="https://www.prosperafrica.gov/about/" target="_blank"
        >Learn more here</a
      >
    </p> -->
    <h5 class="privacy-disclaimer">
      <inline-svg src="media/icons/custom/privacy.svg" />
      We handle your data with care. Please see our confidentiality and privacy
      terms <router-link to="/terms">here</router-link>
    </h5>
  </div>
</template>

<script>
export default {
  name: "contact-tab",
};
</script>

<style lang="scss" scoped>
.contact-tab {
  color: #fff;
  text-align: center;
  padding-bottom: 150px;
  a {
    color: #00a3ff;
  }
  h3 {
    color: #fff;
    font-size: 40px;
    margin-bottom: 27px;
  }
  p {
    color: #fff;
    font-size: 18px;
    font-weight: 500;
    text-align: center;
    margin: 0 auto;
    max-width: 700px;
    font-family: Poppins, Helvetica, "sans-serif" !important;
  }
}
.privacy-disclaimer {
  text-align: center;
  color: #c8355d;
  font-size: 18px;
  font-weight: 600;
  margin-top: 30px;
  svg {
    vertical-align: bottom;
    margin-right: 5px;
  }
}
</style>
